import React from "react";
import "./EAProgressBar.scss";

interface IProps {
  currentStep: number;
  totalSteps: number;
}

const EAProgressBar: React.FC<IProps> = ({ currentStep, totalSteps }) => {
  const percentage = Math.round((currentStep / totalSteps) * 100);

  return (
    <div className="ea-progress-bar">
      <div className="ea-progress-bar__container">
        <div className="ea-progress-bar__fill" style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
};

export default EAProgressBar;

